import React from 'react';
import PropTypes from 'prop-types';
import { BOOK_TYPE, LABEL } from '../../../../../../constants/shared/TrcConstants';
import SectionHeader from '../../SectionHeader';
import { getScoreLabel } from '../../../../../../utils/shared/trcUtils';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const { FICTION } = BOOK_TYPE;
const { RETELLING } = LABEL;

const Retelling = ({ retellings, bookType, retellScore }) =>
    retellScore.complete ? (
        <section className="section-block">
            <SectionHeader
                titles={[
                    RETELLING,
                    getScoreLabel(retellings.filter(ret => ret.correct).length, retellings.length),
                ]}
            />
            {retellings.map(({ text, type, correct }, index) => {
                return (
                    <div key={generateReactKey(index, text)} className="paragraph-holder">
                        <p>
                            <b>{bookType === FICTION ? type : `Fact ${index + 1}`}</b>: {text}
                        </p>
                        <span className={`indication ${correct ? 'done' : 'cancel'}`} />
                    </div>
                );
            })}
        </section>
    ) : (
        <h4>Retelling has not been administered</h4>
    );

Retelling.defaultProps = {
    retellings: [],
    bookType: null,
    retellScore: {},
};

Retelling.propTypes = {
    retellings: PropTypes.array,
    bookType: PropTypes.string,
    retellScore: PropTypes.object,
};

export default Retelling;
